/*
 *
 *  sagas
 *
 */

import { call, take, put, race, select, all, delay } from "redux-saga/effects"

import {
  LOAD_RECORDS_META_DATA,
  CREATE_NOTIFICATION_DETAILS,
  DELETE_NOTIFICATION_DETAILS,
  UPDATE_NOTIFICATION_DETAILS,
  LOAD_RECORD_NOTIFICATION_DETAILS,
  UPDATE_NOTIFICATION_CHECKBOX,

} from "./constants"

import {
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  createNotificationRecordError,
  createNotificationRecordSuccess,

  updateNotificationRecordError,
  updateNotificationRecordSuccess,

  deleteNotificationRecordError,
  deleteNotificationRecordSuccess,

  loadNotificationDetails,
  loadNotificationDetailsSuccess,
  loadNotificationDetailsError,

  updateCheckboxError,
  updateCheckboxSuccess,


} from "./actions"

import {
  loadRecordsMetaData,
  createNotificationRecord,
  deleteNotificationRecord,
  updateNotificationRecord,
  loadRecordNotificationDetails,
  updateCheckboxApi
} from "./remotes"

import { selectSession } from "../session/selectors"
import { roleIds } from "../../helpers/tools"

function* loadRecordNotificationDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_RECORD_NOTIFICATION_DETAILS),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadNotificationDetails(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadRecordNotificationDetails, id)

        if (result) {
          yield put(loadNotificationDetailsSuccess(result.data))
        } else {
          yield put(loadNotificationDetailsError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadNotificationDetailsError(
            (error && error.response && error.response.message) ||
            "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* createNotificationRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(CREATE_NOTIFICATION_DETAILS),
    })
    const { submitValue } = create || {}
    // console.log("records-create", submitValue, setSubmitting)
    if (create) {
      console.log("records", submitValue)

      // yield call(setSubmitting, true)
      try {
        console.log("create records", submitValue)
        yield call(createNotificationRecord, submitValue)

        console.log("create records", submitValue)

        var successVal = createNotificationRecordSuccess(
          submitValue,
          "Record Created Successfully"
        )


        yield put(successVal)
      } catch (error) {
        yield put(
          createNotificationRecordError(
            (error && error.response && error.response.message) ||
            "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}






function* updateNotificationRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { edit } = yield race({
      edit: take(UPDATE_NOTIFICATION_DETAILS),
    })

    // console.log("FFFF &&& Lokesh Func ->", edit)

    const { updateNotificationData } = edit || {}
    if (edit) {
      // yield call(setSubmitting, true)

      try {
        yield call(updateNotificationRecord, updateNotificationData)
        // yield delay(1000)
        yield put(
          updateNotificationRecordSuccess(
            updateNotificationData,
            "Record Updated Successfully"
          )
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          updateNotificationRecordError(
            (error && error.response && error.response.message) ||
            "Update Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}




function* deleteNotificationRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { del } = yield race({
      del: take(DELETE_NOTIFICATION_DETAILS),
    })
    const { deleteNotificationData } = del || {}
    if (del) {

      try {
        yield call(deleteNotificationRecord, deleteNotificationData)
        console.log(deleteNotificationData, "saga for delete event")

        yield put(
          deleteNotificationRecordSuccess(
            deleteNotificationData,

            "Record Deleted Successfully"
          )
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          deleteNotificationRecordError(
            (error && error.response && error.response.message) ||
            "Delete Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}
function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
      let sessionDetails
      while (true) {
        // eslint-disable-line no-constant-condition
        const sessionInStore = yield select(selectSession())

        const { user = {} } = sessionInStore
        if (user && Object.keys(user).length > 0) {
          sessionDetails = sessionInStore
          break
        }
        yield delay(500)
      }

      let company
      let branch
      if (
        sessionDetails &&
        sessionDetails.user &&
        roleIds.includes(sessionDetails.user.roleId)
      ) {
        company = yield call(loadRecordsMetaData, "company", "post")
        branch = yield call(loadRecordsMetaData, "branch", "post")
      } else {
        company =
          (sessionDetails &&
            sessionDetails.user &&
            sessionDetails.user.company &&
            sessionDetails.user.company.length > 0 &&
            sessionDetails.user.company.map((_) => _.detail)) ||
          []
        branch =
          (sessionDetails &&
            sessionDetails.user &&
            sessionDetails.user.branch &&
            sessionDetails.user.branch.length > 0 &&
            sessionDetails.user.branch.map((_) => _.detail)) ||
          []
      }

      let recordsMetaData = {
        companyOptions:
          (company &&
            company.data &&
            company.data.length > 0 &&
            company.data.map((c) =>
              Object.assign({}, { label: c.name, value: c._id })
            )) ||
          (company &&
            company.length > 0 &&
            company.map((c) =>
              Object.assign({}, { label: c.name, value: c._id })
            )) ||
          [],
        branchOptions:
          (branch &&
            branch.data &&
            branch.data.length > 0 &&
            branch.data.map((c) =>
              Object.assign(
                {},
                { label: c.name, value: c._id, companyId: c.companyId }
              )
            )) ||
          (branch &&
            branch.length > 0 &&
            branch.map((c) =>
              Object.assign(
                {},
                { label: c.name, value: c._id, companyId: c.companyId }
              )
            )) ||
          [],
      }

      yield put(loadRecordsMetaDataSuccess(recordsMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
          "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}

// CHECKBOXUPDATE SAGA

function* updateCheckboxSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { edit } = yield race({
      edit: take(UPDATE_NOTIFICATION_CHECKBOX),
    })

    // console.log("FFFF &&& Lokesh Func ->", edit)

    const { checkboxData } = edit || {}
    if (edit) {
      // yield call(setSubmitting, true)

      try {
        yield call(updateCheckboxApi, checkboxData)
        // yield delay(1000)
        yield put(
          updateCheckboxSuccess(
            checkboxData,
            "Record Updated Successfully"
          )
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          updateCheckboxError(
            (error && error.response && error.response.message) ||
            "Update Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadRecordsMetaDataSaga(),
    loadRecordNotificationDetailsSaga(),
    createNotificationRecordSaga(),
    updateNotificationRecordSaga(),
    deleteNotificationRecordSaga(),
    updateCheckboxSaga(),

  ])
}
